import React from 'react';
import {StorageKey} from "../../../enums/StorageKey";
import {t} from "@lingui/macro";
import {EyeInvisibleOutlined} from "@ant-design/icons";
import ContactTypes from "../../ContactTypes";
import {EmailTd, EmailTdWidth} from "../../Table/Common/EmailTd";
import {CustomFieldHelper} from "../../../shared/CustomFieldHelper";

function getColumns(props, fields) {
    return [
        {
            key: 'line',
            width: 55,
            align: 'right',
            fixed: 'left',
            render: (text, record) => record.line,
        },
        {
            title: t`Legal Name`,
            dataIndex: 'contact_id',
            key: 'contact_id',
            fixed: 'left',
            render: (text, record) => (
                <div style={{ lineHeight: '18px'}}>
                    <span>{record.legal_name}</span>
                        &nbsp;
                    {record.is_archived ? <EyeInvisibleOutlined /> : null}
                </div>
            ),
        },
        {
            title: t`Contact Code`,
            dataIndex: "contact_code",
            key: "contact_code",
            render: text => <div style={{ lineHeight: '16px'}}>{text}</div>,
        },
        {
            title: t`Type`,
            dataIndex: 'type',
            key: 'type',
            width: 90,
            render: (text, record) => <ContactTypes record={record} />,
        }, {
            title: t`Other Name`,
            dataIndex: "other_name",
            key: "other_name",
            render: text => <div style={{ lineHeight: '16px'}}>{text || "-"}</div>,
        }, {
            title: t`Billing First Name`,
            dataIndex: "billing_first_name",
            key: "billing_first_name",
            render: text => <div style={{ lineHeight: '16px'}}>{text || "-"}</div>,
        }, {
            title: t`Billing Last Name`,
            dataIndex: "billing_last_name",
            key: "billing_last_name",
            render: text => <div style={{ lineHeight: '16px'}}>{text || "-"}</div>,
        }, {
            title: t`Shipping First Name`,
            dataIndex: "shipping_first_name",
            key: "shipping_first_name",
            render: text => <div style={{ lineHeight: '16px'}}>{text || "-"}</div>,
        }, {
            title: t`Shipping Last Name`,
            dataIndex: "shipping_last_name",
            key: "shipping_last_name",
            render: text => <div style={{ lineHeight: '16px'}}>{text || "-"}</div>,
        },
        {
            title: t`Reg / ID No`,
            dataIndex: "reg_no",
            key: "reg_no",
            render: text => <div style={{ lineHeight: '16px'}}>{text || "-"}</div>,
        },
        {
            title: t`Email`,
            dataIndex: 'email',
            key: 'email',
            width: EmailTdWidth,
            align: 'left',
            render: text => <EmailTd email={text || '-'} />,
        },
        {
            title: t`Telephone`,
            dataIndex: 'phone_no',
            key: 'phone_no',
            align: 'left',
            render: text => <div style={{ lineHeight: '16px'}}>{text || "-"}</div>,
        },
        ...CustomFieldHelper.getColumns(fields.contact, true),
    ];
}

export default {
    storageKey: StorageKey.contact_group,
    required: [
        'line',
        'contact_id',
        'type',
    ],
    defaulto: [
        'contact_code',
        'email',
        'phone_no',
    ],
    getColumns,
};
